// Specialty sandwich components - just a few examples
const specialtySandwichComponents = [
  // Star Special components
  {
    specialty_id: 1,
    component_type: 'meat',
    component_id: 1, // Corned beef
    quantity: 1
  },
  {
    specialty_id: 1,
    component_type: 'cheese',
    component_id: 1, // Swiss
    quantity: 1
  },
  {
    specialty_id: 1,
    component_type: 'bread',
    component_id: 1, // Rye
    quantity: 1
  },
  {
    specialty_id: 1,
    component_type: 'topping',
    component_id: 3, // Coleslaw
    quantity: 1
  },
  {
    specialty_id: 1,
    component_type: 'dressing',
    component_id: 8, // Russian
    quantity: 1
  },
  // Super Corned Beef components (formerly Star Super)
  {
    specialty_id: 2,
    component_type: 'meat',
    component_id: 1, // Corned Beef
    quantity: 1
  },
  {
    specialty_id: 2,
    component_type: 'cheese',
    component_id: 1, // Swiss
    quantity: 1
  },
  {
    specialty_id: 2,
    component_type: 'bread',
    component_id: 1, // Rye
    quantity: 1
  },
  {
    specialty_id: 2,
    component_type: 'topping',
    component_id: 1, // Lettuce
    quantity: 1
  },
  {
    specialty_id: 2,
    component_type: 'topping',
    component_id: 2, // Tomato
    quantity: 1
  },
  {
    specialty_id: 2,
    component_type: 'dressing',
    component_id: 1, // Mayo
    quantity: 1
  },

  // Reuben components
  {
    specialty_id: 4,
    component_type: 'meat',
    component_id: 1, // Corned beef
    quantity: 1
  },
  {
    specialty_id: 4,
    component_type: 'cheese',
    component_id: 1, // Swiss
    quantity: 1
  },
  {
    specialty_id: 4,
    component_type: 'bread',
    component_id: 1, // Rye
    quantity: 1
  },
  {
    specialty_id: 4,
    component_type: 'topping',
    component_id: 4, // Sauerkraut
    quantity: 1
  },
  {
    specialty_id: 4,
    component_type: 'dressing',
    component_id: 8, // Russian
    quantity: 1
  },
  {
    specialty_id: 4,
    component_type: 'preparation',
    component_id: 3, // Grilled
    quantity: 1
  },
  
  // Harry's Combo components
  {
    specialty_id: 10,
    component_type: 'meat',
    component_id: 1, // Corned beef
    quantity: 1
  },
  {
    specialty_id: 10,
    component_type: 'meat',
    component_id: 2, // Pastrami
    quantity: 1
  },
  {
    specialty_id: 10,
    component_type: 'cheese',
    component_id: 1, // Swiss
    quantity: 1
  },
  {
    specialty_id: 10,
    component_type: 'bread',
    component_id: 5, // Onion roll
    quantity: 1
  },
  {
    specialty_id: 10,
    component_type: 'dressing',
    component_id: 8, // Russian
    quantity: 1
  },
  // The Pastrami Special components
  {
    specialty_id: 20,
    component_type: 'meat',
    component_id: 2, // Pastrami
    quantity: 1
  },
  {
    specialty_id: 20,
    component_type: 'cheese',
    component_id: 1, // Swiss
    quantity: 1
  },
  {
    specialty_id: 20,
    component_type: 'bread',
    component_id: 1, // Rye
    quantity: 1
  },
  {
    specialty_id: 20,
    component_type: 'topping',
    component_id: 3, // Coleslaw
    quantity: 1
  },
  {
    specialty_id: 20,
    component_type: 'dressing',
    component_id: 8, // Russian
    quantity: 1
  },
  // The Turkey Special components
  {
    specialty_id: 21,
    component_type: 'meat',
    component_id: 3, // White Turkey Breast
    quantity: 1
  },
  {
    specialty_id: 21,
    component_type: 'cheese',
    component_id: 1, // Swiss
    quantity: 1
  },
  {
    specialty_id: 21,
    component_type: 'bread',
    component_id: 1, // Rye
    quantity: 1
  },
  {
    specialty_id: 21,
    component_type: 'topping',
    component_id: 3, // Coleslaw
    quantity: 1
  },
  {
    specialty_id: 21,
    component_type: 'dressing',
    component_id: 8, // Russian
    quantity: 1
  },
  // The Super Turkey components
  {
    specialty_id: 22,
    component_type: 'meat',
    component_id: 3, // White Turkey Breast
    quantity: 1
  },
  {
    specialty_id: 22,
    component_type: 'cheese',
    component_id: 1, // Swiss
    quantity: 1
  },
  {
    specialty_id: 22,
    component_type: 'bread',
    component_id: 1, // Rye
    quantity: 1
  },
  {
    specialty_id: 22,
    component_type: 'topping',
    component_id: 1, // Lettuce
    quantity: 1
  },
  {
    specialty_id: 22,
    component_type: 'topping',
    component_id: 2, // Tomato
    quantity: 1
  },
  {
    specialty_id: 22,
    component_type: 'dressing',
    component_id: 1, // Mayo
    quantity: 1
  }
];

export default specialtySandwichComponents;